import { environmentInfo } from "@shared";
import { DeviceInfo } from "ngx-device-detector";
import { UserProfile } from "./user-profile";

export class Metadata {
    localId!: string;
    createdDate!: Date;
    updatedDate?: Date;
    updatedBy?: UserProfile;
    channel: string = 'Edara PWA';
    organizationInfo!: OrganizationInfo;
    createdBy!: UserProfile;
    syncInfo?: SyncInfo;
    deviceInfo?: DeviceInfo;
    environmentInfo?: environmentInfo;
    replicationInfo?: replicationInfo;
}

export class OrganizationInfo {
    id!: string;
    name!: string;
}

export class SyncInfo {
    syncStatus!: string;
    syncedDate?: Date;
    syncedBy?: UserProfile;
    syncStatusMessage?: string;
    /** HTTP-class outcome of the last backend answer: 200, 400 (business rejection) or 500. */
    syncStatusCode?: number;
    processingStartedAt?: Date;
    processingCompletedAt?: Date;
}

export class replicationInfo {
    replicaStorageType: string = ReplicaStorageType.LiteDB;
    replicationDate?: Date;
    restoreDate?: Date;
}

export enum ReplicaStorageType {
    LiteDB = "LiteDB"
}